import { createAction, props } from '@ngrx/store';

export const ToggleHelpTextStatus = createAction('[Wizard- Set Up]: Toggle Help Text Status');

export const CampaignSchemaChanged = createAction(
  '[Wizard- Set Up]: Campaign Schema Changed',
  props<{ campaignSchema: string }>(),
);

export const CampaignCountryChanged = createAction(
  '[Wizard- Set Up]: Campaign Country Changed',
  props<{ campaignCountry: string }>(),
);

export const CampaignSelectionTargetChanged = createAction(
  '[Wizard- Set Up]: Campaign Selection Target Changed',
  props<{ campaignSelectionTarget: string }>(),
);

export const ShowSchemaError = createAction('[Wizard- Set Up]: Show Schema Error');

export const HideSchemaError = createAction('[Wizard- Set Up]: Hide Schema Error');

export const ShowCountryError = createAction('[Wizard- Set Up]: Show Country Error');

export const HideCountryError = createAction('[Wizard- Set Up]: Hide Country Error');

export const ClickedNext = createAction('[Wizard- Set Up]: Clicked Next', props<{ clickedNext: boolean }>());
